import useWindowSize from '@/hooks/useWindowSize';
import { ManagerTenantDebitOrder } from '@/interfaces/api/models';
import billingService from '@/services/billing-service';
import { useRouter } from 'next/router';
import { FC, useEffect, useRef, useState } from 'react';
import { createFileRoute } from '@tanstack/react-router'

const DebitOrderPage: FC = () => {

    const router = useRouter();
    const { t, f } = router.query as { t: string, f: string | undefined }; // TODO(tanstack-router): verify router.query → useParams/useSearch

    const [isLoading, setIsLoading] = useState(true);
    const [debitOrder, setDebitOrder] = useState<ManagerTenantDebitOrder | undefined>();

    const iframeRef = useRef<any>();
    const canSendIframeMessages = useRef(false);
    const windowSize = useWindowSize();

    const getDebitOrderDebugDebounce = useRef(false)
    const getDebitOrder = async () => {
        // when debugging useEffect gets called twice
        if (getDebitOrderDebugDebounce.current) return;
        getDebitOrderDebugDebounce.current = true;

        setIsLoading(true);
        let debitOrderResult = await billingService.initDebitOrder(t, f === 'true' ? true : f === 'false' ? false : undefined);
        setDebitOrder(debitOrderResult);
    }

    const sendWindowSizeToIFrame = () => {

        if (!canSendIframeMessages.current) return;

        (iframeRef.current as any).contentWindow.postMessage({
            scType: "setWindowSize",
            width: windowSize.width,
            height: windowSize.height
        }, "*")
    };

    const sendLocationToIFrame = () => {

        if (!canSendIframeMessages.current) return;

        (iframeRef.current as any).contentWindow.postMessage({
            scType: "setWindowLocation",
            location: window.location.href
        }, "*")
    };

    const handleMessage = (event: any) => {
        if (!event || !event.data) return;
        switch (event.data.scType) {
            case "getWindowSize":
                canSendIframeMessages.current = true;
                sendWindowSizeToIFrame();
                sendLocationToIFrame();
                setIsLoading(false);
                break;
            case "close":
                window.opener.postMessage({
                    scType: "close"
                }, "*");
                break;
            default:
                break;
        }

    }

    useEffect(() => {

        if (!router.isReady) return;

        getDebitOrder();

        setTimeout(() => {
            document.title = "ServCraft - Debit Order";
        }, 1000);
        

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        }
    }, [router.isReady]);

    useEffect(() => {
        sendWindowSizeToIFrame();
    }, [windowSize]);

    const loadingScreen = (<>
        <div style={{ position: "fixed", top: 0, right: 0, bottom: 0, left: 0, background: "white" }}>
            <div style={{ textAlign: "center", position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)", fontSize: "0.8rem" }}>
                <img src="https://manager.servcraft.co.za/Content/Images/ServCraftLogoDark.svg" width="200px" />
                {/* <img src="http://localhost:54498/Content/Images/ServCraftLogoDark.svg" width="200px" /> */}
                <div>Loading your debit order...</div>
            </div>
        </div>
    </>);

    return (<>

        {debitOrder &&
            <div style={{ width: "100vw", height: "calc(100vh - 5px)" }}>
                <iframe ref={iframeRef as any} src={debitOrder.Url} height="100%" width="100%" frameBorder={0} />
            </div>
        }

        {isLoading &&
            loadingScreen
        }

        {!isLoading && !debitOrder &&
            <div>Something went wrong!</div>
        }
        <style jsx>{`
            
        `}</style>
    </>);
};

export default DebitOrderPage;

export const Route = createFileRoute('/debit-order')({ component: DebitOrderPage })
